import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

/**
 * Lädt die Übersetzungsdateien aus `assets/i18n/<lang>.json`.
 *
 * Bewusst als eigener Loader implementiert, damit kein zusätzliches Paket
 * (`@ngx-translate/http-loader`) erforderlich ist.
 */
@Injectable()
export class TranslateHttpLoader extends TranslateLoader {
  private readonly http = inject(HttpClient);

  public getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`assets/i18n/${lang}.json`);
  }
}
